export default "__VITE_ASSET__DoJdL_FR__"